import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UpdaterService {
  private readonly swUpdater = inject(SwUpdate);
  private readonly _snack = inject(MatSnackBar);

  private updaterActive = false;

  public async checkForUpdates() {
    if (!this.swUpdater.isEnabled) return false;

    try {
      return await this.swUpdater.checkForUpdate();
    } catch (error) {
      console.error('Update-Pruefung fehlgeschlagen', error);
      return false;
    }
  }

  private async installUpdate() {
    if (!this.swUpdater.isEnabled) return;

    try {
      await this.swUpdater.activateUpdate();
      document.location.reload();
    } catch (error) {
      console.error('Update konnte nicht installiert werden', error);
      this._snack.open('Update konnte nicht installiert werden.', 'OK', {
        duration: 4000,
      });
    }
  }

  public initUpdater() {
    if (this.updaterActive || !this.swUpdater.isEnabled) return;

    this.updaterActive = true;

    this.swUpdater.versionUpdates
      .pipe(
        filter(
          (event): event is VersionReadyEvent => event.type === 'VERSION_READY',
        ),
      )
      .subscribe((event) => {
        console.info('Neue Version gefunden', {
          currentVersion: event.currentVersion,
          latestVersion: event.latestVersion,
        });

        this._snack.open(
          'Es ist ein neues Update verfügbar, es wird nun automatisch installiert...',
          'OK',
          { duration: 3000 },
        );

        window.setTimeout(() => {
          void this.installUpdate();
        }, 1500);
      });
  }
}
